<template>
    <div class="container container--fluid">
        <v-snackbar v-model="snackbar" :top="true" :color="color" :timeout="6000">
            <span v-if="snackbar_msg!=null">{{ snackbar_msg }}</span>
            <v-btn dark text @click="snackbar = false">Close</v-btn>
        </v-snackbar>

        <v-card class="no-display">
            <v-card-title>
                Division Details
                <v-spacer></v-spacer>
            </v-card-title>
            <v-card-text>
                <v-row>
                    <v-col cols="2">
                        <v-text-field v-model="ay" label="Academic Year." readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="standard" label="Standard" readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="division" label="Division" readonly filled outlined dense></v-text-field>
                    </v-col>
                    <v-col cols="2">
                        <v-text-field v-model="teacher" label="Teacher" readonly filled outlined dense></v-text-field>
                    </v-col>
                </v-row>
            </v-card-text>
        </v-card>
        <!-- - <v-row>
            <v-col>
              <v-card >
                <div>
                  <v-data-table id="admitted-student-report"
                  :headers="headers"
                  :items="records"
                  :search="search"
                   :items-per-page="-1"
                  >
                        <template v-slot:top>
          <v-toolbar flat color="white" align="center" justify="center">
            <v-toolbar-title>Attendance Report</v-toolbar-title>

            <v-divider class="mx-4" inset vertical></v-divider>
            <v-spacer></v-spacer>
            <v-text-field
              v-model="search"
              append-icon="search"
              label="Search"
              single-line
              hide-details
              class="no-display"
            ></v-text-field>

              

             <v-btn
              class="ma-2 no-display"
              tile
              outlined
              color="warning"
              @click="print()"
            
            > 
             <v-icon left>mdi-printer</v-icon> Print <v-icon right></v-icon>
            </v-btn>

            <download-excel
              class="ma-2 no-display"
              color="primary"
              dark
              :data="records"
              :fields="xls_header"
              worksheet="My Worksheet"
              name="Attendance Report.xls"
              :title="xls_title"
              ><v-btn class="ma-2 no-display" tile outlined color="success">
                <v-icon left>mdi-file-excel</v-icon> Excel
                <v-icon right>mdi-download</v-icon>
              </v-btn>
            </download-excel> 
          </v-toolbar>
        </template>
                        </v-data-table>
                </div>
                </v-card>
            </v-col>
    </v-row> -->
        <div>
            <v-card class="card-body">
                <v-card-text>
                    <table id="admitted-student-report" dense class="display mytable" style="width: auto;" :items-per-page="-1">
                        <thead class="mytable">
                            <tr>
                                <th v-for="(hl, index) in headers" :key="index">
                                    {{ hl.text }}
                                </th>
                            </tr>
                        </thead>
                        <tbody>
                            <tr v-for="(fl, index) in records" :key="index">
                                <td v-for="(hl, index1) in headers" :key="index1">{{fl[hl.value]}}</td>
                            </tr>
                        </tbody>
                    </table>
                </v-card-text>
            </v-card>
        </div>
        <v-overlay :value="overlay">
            <v-progress-circular indeterminate size="64">Please Wait Till Loading....</v-progress-circular>
        </v-overlay>
    </div>
</template>
<script>
    import axios from "axios";
    import "@/assets/css/color.css"; // css needs to be imported for each dashboard
    export default {
        data: () => ({
            overlay: false,
            dataTable: null,
            headers: "",
            teacher: "",
            ay: "",
            standard: "",
            division: "",
            search: "",
            records: "",
            xls_header: "",
            xls_title: [],
            snackbar_msg: "",
            color: "",
            snackbar: false,
            headers: [
                { text: "Sr. No.", value: "srno", sortable: true },
                { text: "Roll No", value: "rollno", sortable: true },
                { text: "Name", value: "name", sortable: true },
                { text: "GRno", value: "grno", sortable: true },
                { text: "Total", value: "total", sortable: true },
            ],
        }),
        watch: {
            overlay(val) {
                val = () => {
                    this.overlay = false;
                };
            },
        },
        mounted() {
            this.getStudentAttendanceReport();
            //    $(document).ready(function() {
            //     $('#admitted-student-report').DataTable( {
            //         dom: 'Bfrtip',
            //         buttons: [
            //             'copy', 'csv', 'excel', 'pdf', 'print'
            //         ]
            //     } );
            // } );
            // this.dataTable = $("#admitted-student-report").DataTable({
            //         colReorder: true,
            //         dom: "Bfrtip",
            //         buttons: ["csvHtml5", "excelHtml5", "print"],
            //     });
        },
        methods: {
            getStudentAttendanceReport() {
                if (this.$store.getters.divoff_id == null) {
                    // alert('divoff')
                    this.$router.push({ name: "student-attendance" });
                }
                //this.divoff=this.$store.getters.divoff_id
                const data = {
                    divoff: this.$store.getters.divoff_id,
                    status: localStorage.getItem('setstatus_id'),
                };
                this.overlay = true;
                axios
                    .post("/Academics/getStudentAttendanceReport", data)
                    .then((res) => {
                        if (res.data.msg == "200") {
                            // this.headers=res.data.headers
                            this.records = res.data.records;
                            this.ay = res.data.ay;
                            this.standard = res.data.standard;
                            this.division = res.data.division;
                            this.teacher = res.data.teacher;
                            this.headers = res.data.headers;
                            this.overlay = false;
                            //this.load=true
                        } else {
                        }
                    })
                    .catch((error) => {
                        window.console.log(error);
                    })
                    .finally(() => {
                        this.dataTable = $("#admitted-student-report").DataTable({
                            colReorder: true,
                            dom: "Bfrtip",
                            buttons: ["csvHtml5", "excelHtml5", "print"],
                        });
                        this.overlay = false;
                    });
            },

            print() {
                this.$store.state.drawer = false;
                let that = this;
                /*window.onbeforeprint = function() {
        that.$store.state.drawer = false;
      };*/
                window.onafterprint = function () {
                    that.$store.state.drawer = true;
                };
                setTimeout(function () {
                    window.print();
                }, 100);
            },
        },
    };
</script>
<style scoped>
    .card--flex-toolbar {
        margin-top: -62px;
    }
    .card-body {
        overflow-y: auto;
        max-height: 85vh;
    }
    @media print {
        @page {
            size: landscape;
        }
        body {
            height: 100%;
            width: 100%;
        }
        .no-display,
        .v-input__control,
        input[type="button"],
        input[type="submit"],
        input[type="reset"] {
            display: none !important;
        }
        .dt-button {
            font-size: 14px;
            font-weight: bold;
        }
        .dt-button.buttons-print::before {
            content: "\F42A";
            margin-right: 8px;
            margin-top: 8px;
            font-size: 18px;
            font-family: "Material Design Icons";
        }
        .dt-button.buttons-excel::before {
            content: "\F21B";
            margin-right: 8px;
            margin-top: 8px;
            font-size: 18px;
            font-family: "Material Design Icons";
        }
        .dt-button.buttons-csv::before {
            content: "\FEC2";
            margin-right: 8px;
            margin-top: 8px;
            font-size: 18px;
            font-family: "Material Design Icons";
        }
        button.dt-button:hover:not(.disabled),
        div.dt-button:hover:not(.disabled),
        a.dt-button:hover:not(.disabled) {
            border-color: #ff9800;
            color: #ff9800;
        }
        .dataTables_wrapper .dataTables_filter input[type="search"] {
            border-radius: 2px;
            border: 1px solid #cdcdcd;
            cursor: auto;
        }
        .mytable /deep/ thead th {
            background: #0f2027; /* fallback for old browsers */
            background: -webkit-linear-gradient(to right, #2c5364, #203a43, #0f2027); /* Chrome 10-25, Safari 5.1-6 */
            background: linear-gradient(to right, #2c5364, #203a43, #0f2027); /* W3C, IE 10+/ Edge, Firefox 16+, Chrome 26+, Opera 12+, Safari 7+ */
            background-color: #0f2027 !important;
            color: white !important;
            font-weight: bold !important;
            white-space: nowrap !important;
            text-align: center;
        }
    }
</style>
